// BookingContext.js
import React, { createContext, useState, useContext } from 'react';

// 1. Create the context
const BookingContext = createContext();

// 2. Create the provider component
export const BookingProvider = ({ children }) => {
  const [bookingData, setBookingData] = useState({
    selectedVehicle: null,
    from: '',
    to: '',
    pickupDate: '',
    returnDate: '',
    tripType: 'singleTrip',
    pickupTime: '10:00 AM',
    totalPrice: 0,
    contactName: '',
    contactEmail: '',
    contactMobile: '',
    specialInstructions: '',
    bookingStage: 'initial',
    bookingStatus: 'pending',
    bookingReference: ''
  });

  const updateBookingData = (newData) => {
    setBookingData(prev => ({
      ...prev,
      ...newData
    }));
  };

  const resetBooking = () => {
    setBookingData({
      selectedVehicle: null,
      from: '',
      to: '',
      pickupDate: '',
      returnDate: '',
      tripType: 'singleTrip',
      pickupTime: '10:00 AM',
      totalPrice: 0,
      contactName: '',
      contactEmail: '',
      contactMobile: '',
      specialInstructions: '',
      bookingStage: 'initial',
      bookingStatus: 'pending',
      bookingReference: ''
    });
  };

  const value = {
    bookingData,
    setBookingData: updateBookingData,
    resetBooking
  };

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};

// 3. Create and export the useBooking hook
export const useBooking = () => {
  const context = useContext(BookingContext);
  
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  
  return context;
};

// 4. Export the context itself (optional)
export { BookingContext };